import { h, Component } from 'preact';
import { DateTime } from 'luxon';
import dlv from 'dlv';

import style from './style.less';
import { configure } from '../../../config';

/** Creates image used below header for specific occassion
 */
@configure({
	occasionsBanner: 'singleCube.occasionsBanner'
})
export class OccasionBanner extends Component {

	getActiveOccasion = (occasions) => {
		let now = DateTime.now();

		for (const occasion of Object.values(occasions)) {
			let start = DateTime.fromISO(occasion.start),
				end = DateTime.fromISO(occasion.end).set({ hour: 23, minute: 59 });

			if (now > start && now < end) {
				this.setState({ src: occasion.image });
				return;
			}
		}
	};

	componentWillMount() {
		if (dlv(this.props, 'occasionsBanner.enabled')) this.getActiveOccasion(this.props.occasionsBanner.occasions);
	}

	render({}, { src }) {
		if (!src) return;

		return (
			<img src={src} class={style.image} />
		);
	}
}
